import { motion } from "framer-motion";
import { coursesAnimation } from "../animate";
import { useScroll } from "./useScroll";
import useWindowDimensions from "./useDimension";

const MLCourseDetails1 = (props) => {
  const { width } = useWindowDimensions();
  const [element, controls] = useScroll(width < 1000 ? 0 : 0.25);

  return (
    <div className="details">
      <div className="images">
        <img src={props.img} alt="" />
      </div>
      <motion.div
        className="desc"
        variants={coursesAnimation}
        initial="hidden"
        animate={controls}
        ref={element}
      >
        <h2>
          <span>詳細課程內容:</span>
        </h2>

        <p>
          你對資料科學、人工智慧和機器學習有興趣嗎？本課程將帶你從零開始，循序漸進學習資料分析、視覺化、監督式與無監督學習等主題，並深度了解多種主流演算法（如線性迴歸、決策樹、KMeans、PCA
          等），同時強調理論應用並重，讓你能用 Python
          及主流套件（NumPy、Pandas、Matplotlib 等）將理論落實到實際應用。
        </p>
        <p>
          課程設計 7 個實作
          Lab，讓你以真實資料集練習資料清理、特徵工程、模型訓練與評估，全面提升資料思維與解決問題的能力。無論你是新手還是進階學習者，都能在這門課獲得紮實的
          AI 與機器學習知識，現在就加入我們，開啟你的 AI 之旅吧！
        </p>
      </motion.div>
    </div>
  );
};

export default MLCourseDetails1;
